// -- FIELDS
const _FIELDS = [
  {
    label: "name",
    type: "text",
    name: "nome",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  }
]

// -- HEADERS
const _HEADERS = [
  {
    label: "name",
    align: "left",
    value: "nome"
  },
  {
    label: "actions",
    value: "action"
  }
]

const TIPO_AT = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
}

export default TIPO_AT
